import { SearchItem, SearchItemLocationType } from '@/app/types'
import { kebabCase } from 'lodash'

export const buildSearchDestinationPath = ({
	lang,
	isHotelPage,
	isSameHotelPageSearch,
	selectedItem,
}: {
	lang?: string
	isHotelPage?: boolean
	isSameHotelPageSearch: boolean
	selectedItem: SearchItem
}) => {
	let basePath = lang ? `/${lang}` : ''

	if (isHotelPage && isSameHotelPageSearch) {
		basePath += '/hotel'
	}

	const {
		loctype,
		kayakType,
		country,
		region,
		cityonly,
		name,
		airportname,
	} = selectedItem

	const effectiveLoctype =
		kayakType === 'touristregion'
			? SearchItemLocationType.TOURISTREGION
			: loctype

	switch (effectiveLoctype) {
		case SearchItemLocationType.AIRPORT: {
			const airportRegion = region || cityonly || name
			return `${basePath}/${kebabCase(country)}/${kebabCase(
				airportRegion || ''
			)}/ap/${encodeURIComponent(airportname || name)}`
		}
		case SearchItemLocationType.HOTEL:
			return `${basePath}/${kebabCase(country)}/${kebabCase(
				region || cityonly
			)}/${kebabCase(cityonly)}/${encodeURIComponent(name)}`
		case SearchItemLocationType.FREEREGION:
			if (selectedItem.country) {
				return `/${kebabCase(selectedItem.country)}/${kebabCase(name)}/`
			}
			return `${basePath}/${kebabCase(selectedItem.smartyDisplay)}/${kebabCase(
				selectedItem.smartyDisplay
			)}/freereg/`
		case SearchItemLocationType.CITY:
			return `${basePath}/${kebabCase(country)}/${kebabCase(
				region || cityonly
			)}/${kebabCase(cityonly)}`
		case SearchItemLocationType.TOURISTREGION:
			return `${basePath}/${kebabCase(country)}/${kebabCase(
				name || region || cityonly
			)}`
		case SearchItemLocationType.LM:
			return `${basePath}/${kebabCase(country)}/${kebabCase(
				region || cityonly
			)}/${kebabCase(cityonly)}/lm/${encodeURIComponent(name)}`
		case SearchItemLocationType.HOOD:
			return `${basePath}/${kebabCase(country)}/${kebabCase(
				region || cityonly
			)}/${kebabCase(cityonly)}/hood/${encodeURIComponent(name)}`
		default:
			return `${basePath}/${kebabCase(country)}${region ? `/${kebabCase(region)}` : ''
				}`
	}
}